import store from '@/store'

export default class Subscription {
  static getMatchedSubscribingAccount(username) {
    const subscribingUserInfos = store.getters.subscribingUserInfos
    if (subscribingUserInfos) {
      for (let i = 0; i < subscribingUserInfos.length; i++) {
        const ui = subscribingUserInfos[i]
        if (username === ui.username) {
          return ui
        }
      }
    }
    return {}
  }
}
